import { Typography } from "@mui/material";
import { type IRiskScoring, average } from "components/Risk/defaults";
import { useFormikContext } from "formik";

interface CategoryObject {
  [category: string]: { description: string; score: number };
}

const SupplierBuyerScore = ({
  party,
}: {
  title: string;
  party: "supplier" | "buyer" | "tradingRelationship";
}) => {
  const formikProps = useFormikContext<IRiskScoring>();

  function getScore(categoryType: CategoryObject): number[] {
    return Object.values(categoryType ?? {}).map((item) => item?.score ?? 0);
  }

  const currentPartyData = (formikProps?.values as any)?.[party] || {};
  const currentScores = getScore(currentPartyData);
  const currentAverage = average(currentScores);

  return <Typography>{currentAverage?.toFixed(1) || "0.0"}</Typography>;
};

export default SupplierBuyerScore;
